import script from "./Tournaments.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tournaments.vue?vue&type=script&lang=ts&setup=true"

import "./Tournaments.vue?vue&type=style&index=0&id=93fe541a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93fe541a"]])

export default __exports__